import type { Currency } from '@weft/types';
import { type PriceTier } from '@weft/types';
import { formatNumber, purge } from '@weft/utils';
import type { ColumnsType } from 'antd/es/table';
import { getEmptyCellContent } from 'apps/app/src/services/table/get-empty-cell-content';
import { Price } from '../../../components/design/Price';
import { TableToCell } from '../../../components/design/table/table-components/table-body/table-body-components/table-row/table-row-components/table-cell/TableToCell';

export function getUsageProductVariantTableColumns(currency: Currency, isFlatRate: boolean, isTieredSubscriptionProduct: boolean): ColumnsType<Partial<PriceTier>> {
  return purge([
    {
      title: 'From',
      dataIndex: 'from',
      className: 'bg-white before:hidden',
      render: (from) => (
        <p>
          {formatNumber(from)}
        </p>
      ),
    },
    {
      title: 'To',
      dataIndex: 'to',
      className: 'bg-white before:hidden',
      render: (to) => (
        <TableToCell
          to={to}
          className='before:absolute before:inset-y-1 before:left-0 before:my-auto before:h-4 before:w-[1px] before:bg-[#DDE9F0] before:content-[""]'
        />
      ),
    },
    !isTieredSubscriptionProduct ? {
      title: 'Per Unit',
      dataIndex: 'price',
      className: 'bg-white',
      render: (price) => (
        <Price
          currency={currency}
          align="center"
        >
          {price}
        </Price>
      ),
    } : undefined,
    isFlatRate ? 
      {
        title: isTieredSubscriptionProduct ? 'Fixed Rate' : 'Flat Rate',
        dataIndex: 'flatRate',
        className: 'bg-white',
        render: (flatRate) => (
          <Price
            currency={currency}
            align="center"
            marginX="auto"
          >
            {flatRate ?? getEmptyCellContent()}
          </Price>
        ),
      } : undefined,
  ]);
}
